import { linkSystemProductsTranslations } from "./index";

export const LINK_SYSTEM_PRODUCTS_EN_US: linkSystemProductsTranslations = {
	title: "Import product",
	subtitle: "Link the imported products with Zig product data",
	helpText:
		"You can now link the imported items to products we already have on the platform, with everything filled in.",
	noCategory: "No category",
	table: {
		systemProduct: "Zig Product Link",
	},
	validation: {
		unlinkedCount: {
			one: "1 product has not been linked. Please link the product before continuing.",
			other:
				"{count} products have not been linked. Please link all products before continuing.",
		},
	},
};
